const Boq = {

    // LABELS
    "boq": "BOQ",
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "document": "Document",
    "search": "Search",

    // TABLE
    "table_department": "DEPARTMENT",
    "table_location": "LOCATION",
    "table_component": "COMPONENT",
    "table_document": "DOCUMENT",

    // ERRORS
    "error_department": "Select Department",
    "error_location": "Select Location",
    "error_component": "Select Component",
    "error_document": "Upload Document",

}

export default Boq;